import { useState, ReactNode, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Login from '../pages/LoginPage';
import { isValidToken } from './utils';

// ----------------------------------------------------------------------

type AuthGuardProps = {
  children: ReactNode;
};

// Adjust the import according to your project structure

export default function AuthGuard({ children }: AuthGuardProps) {
  const accessToken = localStorage.getItem('accessToken');
  const navigate = useNavigate();

  useEffect(() => {
    if (
      !accessToken
      // || !isValidToken(accessToken)
    ) {
      navigate('/login', { replace: true });
    }
  }, [accessToken, navigate]);

  if (
    !accessToken
    // || !isValidToken(accessToken)
  ) {
    return <Login />;
  }
  return <>{children}</>;
}
